import { c as _c } from "react/compiler-runtime";
import { useFilters } from '../../../store';
import { options } from './config';
import Filter from './filter.icon.svg';
import css from './filters.module.scss';
export function Filters() {
  const $ = _c(10);
  const {
    category,
    setCategory
  } = useFilters();
  const filter = options[category];
  const t0 = filter.value;
  let t1;
  if ($[0] !== filter.color) {
    t1 = {
      color: filter.color
    };
    $[0] = filter.color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setCategory) {
    t2 = e => setCategory(e.target.value as typeof category);
    $[2] = setCategory;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <button><Filter /></button>;
    t4 = Object.entries(options).map(_temp);
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== filter.value || $[7] !== t1 || $[8] !== t2) {
    t5 = <select className={css.select} value={t0} style={t1} onChange={t2}>{t3}{t4}</select>;
    $[6] = filter.value;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(t0) {
  const [value, opt] = t0;
  return <option key={value} className={css.option} value={value}><span style={{
      color: opt.color
    }}>{opt.icon}</span>{opt.label}</option>;
}